module.exports = __webpack_public_path__ + "img/weight.08d70b8b.png";